import { getFunctions, httpsCallable } from 'firebase/functions';
import app from './lib/firebase-app';
import './lib/nav';

const funcs = getFunctions(app);
const makeUserAdmin = httpsCallable(funcs, 'makeUserAdmin');
const demoteUserAdmin = httpsCallable(funcs, 'demoteUserAdmin');
const deleteUser = httpsCallable(funcs, 'deleteUser');
const createUser = httpsCallable(funcs, 'createUser');

async function listUsers() {
  try {
    const getUsers = httpsCallable(funcs, 'getUsers');
    const result = await getUsers();
    return result.data.users;
  } catch (err) {
    return Promise.reject(err);
  }
}

function createButton(text, icon) {
  const button = document.createElement('button');
  button.className = 'btn btn-small blue';
  if (icon) {
    const iconEl = document.createElement('i');
    iconEl.className = text ? 'material-icons left' : 'material-icons';
    iconEl.innerHTML = icon;
    button.appendChild(iconEl);
  }
  if (text) {
    const buttonText = document.createTextNode(text);
    button.appendChild(buttonText);
  }
  return button;
}

function showPreloader() {
  const preloader = document.querySelector('.preloader-background');
  preloader.style.display = 'block';
}

function hidePreloader() {
  const preloader = document.querySelector('.preloader-background');
  preloader.style.display = 'none';
}

async function populateUserList() {
  try {
    const users = await listUsers();
    console.log(users);
    const userListTable = document.querySelector('#users tbody');
    const userList = new DocumentFragment();
    users.forEach((user) => {
      const row = document.createElement('tr');
      const emailCell = document.createElement('td');
      emailCell.innerText = user.email;
      row.appendChild(emailCell);
      const actionCell = document.createElement('td');
      if (!user?.claims?.admin) {
        const adminButton = createButton('Make Admin ', 'star');
        adminButton.addEventListener('click', async (e) => {
          e.preventDefault();
          try {
            showPreloader();
            await makeUserAdmin(user);
            populateUserList();
            hidePreloader();
          } catch (err) {
            console.error(err.message);
          }
        });
        actionCell.appendChild(adminButton);
      } else {
        const adminButton = createButton('Demote Admin ', 'star');
        adminButton.addEventListener('click', async (e) => {
          e.preventDefault();
          try {
            showPreloader();
            await demoteUserAdmin(user);
            populateUserList();
            hidePreloader();
          } catch (err) {
            console.error(err.message);
          }
        });
        actionCell.appendChild(adminButton);
      }
      const deleteButton = createButton(null, 'delete');
      deleteButton.addEventListener('click', async (e) => {
        e.preventDefault();
        try {
          showPreloader();
          const result = await deleteUser({ email: user.email });
          console.log(result);
          populateUserList();
          hidePreloader();
        } catch (err) {
          console.error(err.message);
        }
      });
      actionCell.appendChild(deleteButton);
      row.appendChild(actionCell);
      userList.appendChild(row);
    });
    userListTable.replaceChildren(userList);
  } catch (err) {
    console.log(err.message);
  }
}

populateUserList();

const modals = document.querySelectorAll('.modal');
M.Modal.init(modals);

const createUserModal = M.Modal.getInstance(
  document.querySelector('#modal-create-user')
);

const createForm = document.querySelector('#create-user-form');
createForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  showPreloader();
  const email = createForm.email.value;
  const password = createForm.password.value;
  createUserModal.close();
  const result = await createUser({
    email,
    password,
  });
  createForm.reset();
  console.log(result);
  populateUserList();
  hidePreloader();
});
